import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { STORAGE_KEYS as o } from "./storage-manager.js";
import u from "./subscription-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";

var St = /*#__PURE__*/function () {
  function St(t, i, s) {
    _classCallCheck(this, St);

    this.h = t, this.xn = i || !1, this.zn = s, this.qn = new u(), this.Bn = 0, this.Dn = 1;
  }

  _createClass(St, [{
    key: "Gn",
    value: function Gn() {
      return this.xn;
    }
  }, {
    key: "Hn",
    value: function Hn() {
      return this.h.I(o.q.Jn);
    }
  }, {
    key: "setSdkAuthenticationSignature",
    value: function setSdkAuthenticationSignature(t) {
      var i = this.Hn();
      this.h.B(o.q.Jn, t);
      var s = r.xt.Ft;
      new r.qt(s, r.D).setItem(s.$t.Kn, this.Dn, t), i !== t && this.Qs();
    }
  }, {
    key: "Ln",
    value: function Ln() {
      this.h.Xs(o.q.Jn);
      var t = r.xt.Ft;
      new r.qt(t, r.D).br(t.$t.Kn, this.Dn);
    }
  }, {
    key: "subscribeToSdkAuthenticationFailures",
    value: function subscribeToSdkAuthenticationFailures(t) {
      return this.zn.ut(t);
    }
  }, {
    key: "Mn",
    value: function Mn(t) {
      this.zn.St(t);
    }
  }, {
    key: "On",
    value: function On() {
      this.qn.removeAllSubscriptions();
    }
  }, {
    key: "Pn",
    value: function Pn() {
      this.Bn += 1;
    }
  }, {
    key: "Qn",
    value: function Qn() {
      return this.Bn;
    }
  }, {
    key: "Qs",
    value: function Qs() {
      this.Bn = 0;
    }
  }]);

  return St;
}();

export { St as default };